import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {FormComponent, LegendFieldComponent, PasswordInputFieldComponent} from '../../../components/form';

import './StagingLoginFormComponent.scss';
import TextInputFieldComponent from '../../form/TextInputFieldComponent';
import {updateStagingBasic} from '../../../services/authentication/staging/actions';
import {hideModal} from '../../../services/modal/actions';

class StagingLoginFormComponent extends React.Component {

    submit = data => {
        const token = btoa(`${data.username}:${data.password}`);
        const { updateStagingBasic, hideModal } = this.props;
        updateStagingBasic(token);
        hideModal();
        window.location.reload();
    };

    render() {
        const {
            errorMessage,
            requestSubmit,
            errorSubmit,
        } = this.props;

        return (
            <FormComponent
                form="login-form"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                initialValues={{}}
                className="login-form"
                submitText={"Get access to Staging"}>
                <TextInputFieldComponent
                    name="username"
                    placeholder={"Username"}
                    isRequired
                />
                <PasswordInputFieldComponent
                    name="password"
                    placeholder={"Password"}
                    isRequired
                />
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
            </FormComponent>
        );
    }
}

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        errorMessage: state.authentication.error || '',
        requestSubmit: state.authentication.fetching || false,
        errorSubmit: !_.isEmpty(state.authentication.error),
        successSubmit: state.authentication.isAuthenticated,
        i18nForm: state.i18n.feature.form,
    };
};

const mapDispatchToProps = {
    updateStagingBasic,
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(StagingLoginFormComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/staging/StagingLoginFormComponent.js